/* eslint-disable */
import React from "react";
import axios from "axios";

export const basicUrl = `https://py.qubx3d.com/api/v1`;
export const ipAddress = "http://188.166.169.201:8088/api/v1";

const instance = axios.create({
  baseURL: `${basicUrl}`,
});

export const getAuthToken = () => {
  try {
    const raw = localStorage.getItem("user");
    if (!raw) return "";
    const user = JSON.parse(raw);
    let token = user?.access || user?.accessToken || user?.token || "";
    if (typeof token === "string") {
      token = token.trim();
      if (token.startsWith("Bearer ")) {
        token = token.slice(7).trim();
      }
      return token;
    }
    return "";
  } catch (e) {
    return "";
  }
};

export const getAuthHeaders = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const isAuthEndpoint = (url) => {
  if (!url) return false;
  return url.includes("/login") || url.includes("/forgot-password");
};

const authRequestInterceptor = (config) => {
  if (isAuthEndpoint(config.url)) {
    return config;
  }
  const token = getAuthToken();
  if (token) {
    config.headers = config.headers || {};
    const existing = config.headers.Authorization || config.headers.authorization;
    if (existing) {
      delete config.headers.authorization;
      config.headers.Authorization = existing;
      return config;
    }
    delete config.headers.authorization;
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

const handleUnauthorized = (error) => {
  if (
    error.response &&
    error.response.status === 401 &&
    !error.config?.url?.includes("/login")
  ) {
    localStorage.removeItem("user");
    if (window.location.pathname !== "/login") {
      window.location.href = "/login";
    }
  }
  return Promise.reject(error);
};

instance.interceptors.request.use(authRequestInterceptor);
instance.interceptors.response.use((response) => response, handleUnauthorized);
axios.interceptors.request.use(authRequestInterceptor);

export const httpNonToken = instance;
export const endpoints = {
  request: "/request",
  updateRequest: "/request/update",
  createRequest: "/request/create",
  requestStatus: "/status",
  smsTemplates: "/sms/template",
  qubxOperator: "/employeeProfile",
  note: "/note",
  createNote: "/note/create",
  sirvUpload: "/sirv/upload-file/",
  diconSource: "/diconSource",
  requestPrice: "/request/price/",
  updateUser: "/user/update",
  user: "/user/",
  changePassword: "/user/changePassword/",
  createDoctor: "/user/doctor-rc/create",
  notifications: "/notifications",
  updateNotification: "/notifications/update",
  updateGroupNotifications: "/notifications/read",
  updatePatient: "/patient/update",
  patient: "/patient",
  forgetPassword: "/user/forgot-password",
};
